import * as Sentry from "@sentry/angular";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

Sentry.init({
    dsn: "https://7cdec6b4524fdba89177f6ea08a154e7@o60898.ingest.us.sentry.io/4511349520269312",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true
})

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));